import { API_URL as baseApiUrl } from "@/config/env";

export const setupAPIs = {
	getScenario: baseApiUrl + "Scenario/GetScenario?",
	getUserCountries: baseApiUrl + "GetUserCountries?",
	getCGForCountry: baseApiUrl + "CustomerGroup/GetCstmrGrpforCntry?",
	getCGRefData: baseApiUrl + "Scenario/GetCustomerGroupReferenceData?",
	getCGDetail: baseApiUrl + "CustomerGroup/GetCstmrGrpDetail?",
	getRelshipLevel: baseApiUrl + "Scenario/GetTrustLevel",
	getCustomers: baseApiUrl + "CustomerGroup/GetCustomerSrch",

	getPGForCountry: baseApiUrl + "ProductGroup/GetProductGroupsForCountry?",
	getPGDetail: baseApiUrl + "ProductGroup/GetProductGroupDetail?",
	submitCustomerGroup: baseApiUrl + "CustomerGroup/SubmitCstmrGrp",
	saveCustomerGroup: baseApiUrl + "CustomerGroup/SaveCstmrGrp",
	cloneCustomerGroup: baseApiUrl + "CustomerGroup/CloneCstmrGrp",

	submitProductGroupEdit:
		baseApiUrl + "ProductGroup/SubmitProductGroup?isEdittrue",
	saveProductGroupEdit: baseApiUrl + "ProductGroup/SaveProductGroup?isEdittrue",

	submitProductGroupCreate:
		baseApiUrl + "ProductGroup/SubmitProductGroup?isEditfalse",
	saveProductGroupCreate:
		baseApiUrl + "ProductGroup/SaveProductGroup?isEditfalse",

	getProductGroups: baseApiUrl + "ProductGroup/GetProductSrch?",
	getBrandsForCountry: baseApiUrl + "Scenario/GetBrandsForCountry?",

	scDetails: baseApiUrl + "Scenario/GetScenarioDetails?",
	ImportExcel: baseApiUrl + "Scenario/ImportExcel?",
	ImportExcelSKU: baseApiUrl + "Scenario/ImportExcelSKU?",
	GetProductGroupbyCountry: baseApiUrl + "Scenario/GetProductGroupbyMolecule",
	uploadFileForCustomerGroup:
		baseApiUrl + "CustomerGroup/UploadFileForCustomerGroup",

	downloadAttachment: baseApiUrl + "Define/DownloadFile?",
  getCustomerCountries: baseApiUrl + "Scenario/GetCustomerCountry?"
};
